import { FC } from 'react';
import { useAccess } from '../../hooks/useAccess';
import { useRole } from '../../hooks/useRole';
import { IRoleGoup } from '../../model/IRole';
import NoData from '../common/empty/NoData';
import SearchInputListSkeloton from '../common/skeletons/SearchInputListSkeloton';
import FormBlock from '../form/FormBlock';
import AddRoleLink from './AddRoleLink';
import RoleFormItem from './RoleFormItem';

const RoleForm: FC<{ roleGroup: IRoleGoup }> = ({ roleGroup }) => {
  const { getSettingAccess } = useAccess();
  const { addRole, roles, rolesPending } = useRole(roleGroup);

  return (
    <FormBlock
      title={`${roleGroup.capitalize()} Roles`}
      subTitle={`All ${roleGroup.capitalize()} roles including deleted roles`}
      className="bg-gray-50"
    >
      <div className="flex flex-wrap gap-4 col-span-12">
        {(!!roles?.length && roles.map((role) => (
          <RoleFormItem
            key={`${roleGroup}${role.id}`}
            role={role}
            roleGroup={roleGroup}
          />
        )))
          || (rolesPending && <SearchInputListSkeloton />)
          || <NoData />
        }
      </div>

      {!!getSettingAccess('add_role') && (
        <div className="col-span-12 pl-1">
          <AddRoleLink
            systemRole={roleGroup}
            title={`New ${roleGroup.capitalize()} Role`}
            addRole={addRole}
          />
        </div>
      )}
    </FormBlock>
  );
}

export default RoleForm;
